import Header from 'modules/header/wholesaler/main';
import useGetSaleType from './hooks/usegetSaleType';
import CategoryList from 'components/categoryList/typeSale';
import TypeAdsHelp from 'components/typeAdsHelp';

const TypeAds = () => {
  const {WholesalerTypeSales, isLoading} = useGetSaleType();
  return (
    <>
      <Header title="ثبت آگهی فروش محصول " />
      {!isLoading && (
        <CategoryList list={WholesalerTypeSales} appType="wholesaler" />
      )}
      <div className="pb-[8vh]">
        <TypeAdsHelp app="wholesaler" />
      </div>
    </>
  );
};

export default TypeAds;
